import { useAuthorizationStore } from '@/store/authorizationStore'

function _getCallTranscriptionWhitelist() {
    const ids = import.meta.env.VITE_CALL_TRANSCRIPTION_WHITELIST

    return ids ? ids.split(',') : null
}

function showTranscription() {
    const authorizationStore = useAuthorizationStore()

    const ids = _getCallTranscriptionWhitelist()

    if (!ids) {
        return true
    }

    if (!authorizationStore.user) {
        return false
    }

    return ids.some((id) => id.toString() === authorizationStore.user.id.toString())
}

export {
    showTranscription,
}
